import {MainContent, MainLayoutWithoutStretch} from '../../../Components/Layout/Layout'
import {GoBackHeaderTitle, HeaderActions, HeaderRow} from '../../../Components/Molecules/ViewComponents/ViewHeader'
import React, {useEffect} from 'react'
import {Trans, useTranslation} from 'react-i18next'
import {useNavigation} from 'react-navi'
import {Helmet} from 'react-navi-helmet-async'
import {useAppState} from '../../../state'
import MessageSettingsList from './MessageSettingsList'

interface MessageSettingsViewProps {
  isSystemMessagesView?: boolean
}

const MessageSettingsView = ({isSystemMessagesView}: MessageSettingsViewProps) => {
  const {t} = useTranslation(['messages', 'settings'])
  const nav = useNavigation()
  const {state, actions} = useAppState()

  const goBackLink = isSystemMessagesView ? '/admin' : '/settings'
  const addLink = isSystemMessagesView ? '/admin/messages/create' : '/settings/messages/create'

  useEffect(() => {
    const setup = async () => {
      if (isSystemMessagesView) {
        actions.v1.messages.getSystemMessages()
      } else {
        actions.v1.messages.getAllMessagesForAdmin()
      }
    }
    setup()
  }, [])

  return (
    <MainLayoutWithoutStretch>
      <Helmet title={t('common:routes.messageSettings', 'Message Settings')} />
      <MainContent variant="white">
        <HeaderRow
          description={
            <Trans
              i18nKey="messages:labels.messageSettingsGuide"
              defaults="Here you can create, edit and delete messages for everyone to see."
              components={{br: <br />}}
            />
          }
        >
          <GoBackHeaderTitle
            path={goBackLink}
            label={t('messages:labels.messageSettings', 'Message Settings')}
            backLabel={t('settings:labels.settingsTitle', 'Settings')}
          />
          <HeaderActions onAdd={() => nav.navigate(addLink)} />
        </HeaderRow>
        <MessageSettingsList isSystemMessagesView={isSystemMessagesView} />
      </MainContent>
    </MainLayoutWithoutStretch>
  )
}

export default MessageSettingsView
